import { useState, useEffect } from 'react';
import { fetchEksiAgenda } from '../services/botService';

export function useAgenda() {
    const [agenda, setAgenda] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const refreshAgenda = async (force: boolean = false) => {
        setIsLoading(true);
        setError(null);
        try {
            const results = await fetchEksiAgenda(force);
            setAgenda(results);
        } catch (err) {
            console.error('Failed to fetch agenda:', err);
            setError('Gündem yüklenemedi.');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        refreshAgenda();
    }, []);

    return { agenda, isLoading, error, refreshAgenda };
}
